import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { faEmptySet, IconDefinition } from '@fortawesome/pro-duotone-svg-icons';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ToggleEmailListDialog } from 'src/app/store/dashboard/email-list/email-list-dialog.actions';
import { EmailBehaviourState } from 'src/app/store/samwin/email/email-behaviour/email-behaviour.state';
import { BrickDefinition } from '../../../../samwebDescription/samweb/brickDefinition';

@Component({
   selector: 'samweb-email-list-dialog',
   templateUrl: './email-list-dialog.component.html',
   styleUrls: ['./email-list-dialog.component.scss'],
   changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EmailListDialogComponent implements OnInit {
   @Select(EmailBehaviourState.getOpenEmailWindows)
   public openEmailWindows$: Observable<string[]>;

   @Input()
   public addingBrickSpecialHandlingByOtherBrickInstanceId: string;

   public noResultsIcon: IconDefinition = faEmptySet;

   public brickDefinitions$: Observable<BrickDefinition[]>;

   constructor(private store: Store) {}

   ngOnInit(): void {}

   toggleEmail() {
      this.store.dispatch(new ToggleEmailListDialog());
   }
}
